var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import * as S from './style';
import Image from '../../../components/loggedout/common/Image';
import TickIcon from '../../../../images/onboarding/tick-2.svg';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { GetSurveyDetailsData, SubmitSurvey } from '../../../services/loggedout-api';
import { sendErrorToSentry, sendEventUsingAvo } from '../../../utils/web-helper';
import { appendBaseParams } from '../../../utils/avo-helper';
export var PersonaIdentification = function (props) {
    var getItem = useExtendedLocalStorage('splashverse-onboarding', '').getItem;
    var selectedGrade = getItem('selectedGrade');
    var studentId = getItem("childId");
    var _a = useState([]), optionsData = _a[0], setOptionsData = _a[1];
    var _b = useState(false), dataLoaded = _b[0], setDataLoaded = _b[1];
    var _c = useState([]), personaData = _c[0], setPersonaData = _c[1];
    var _d = useState(0), questionNumber = _d[0], setQuestionNumber = _d[1];
    var _e = useState([]), selectedOptionsMap = _e[0], setSelectedOptionsMap = _e[1];
    var _f = useState(Array(optionsData.length).fill(false)), selectedBooleanMap = _f[0], setSelectedBooleanMap = _f[1];
    var _g = useState(null), nothingSpecificOption = _g[0], setNothingSpecific = _g[1];
    var _h = useState(0), totalQuestions = _h[0], setTotalQuestions = _h[1];
    var _j = useState(false), showErrorMsz = _j[0], setShowErrorMsz = _j[1];
    var nothingSpecificOptionId = 37;
    var submitTypes = {
        next: 'next',
        nothing: 'nothing'
    };
    useEffect(function () {
        var params = {
            survey_code: 'persona_identification',
            grade_code: selectedGrade
        };
        GetSurveyDetailsData(params).then(function (data) {
            if (data) {
                setPersonaData(data['survey_questions']);
                filterNothingSpecificFromOptions(data['survey_questions'][questionNumber]);
                setTotalQuestions(data['survey_questions'].length);
                setDataLoaded(true);
            }
            else {
                console.log('no data found');
            }
        })
            .catch(function (error) {
            var errorInfo = {
                extraMsg: 'error while fetching survey details',
            };
            sendErrorToSentry(error, errorInfo);
            return;
        });
    }, []);
    useEffect(function () {
        sendEventUsingAvo({
            methodName: 'viewedPersonaQuestionScreen',
            params: __assign({ 'questionNo': "".concat(questionNumber + 1) }, appendBaseParams({ settings: {}, courses: [], mathGrade: "", elaGrade: "", grade: "", signupFlow: "" }))
        });
    }, [questionNumber]);
    var filterNothingSpecificFromOptions = function (data) {
        var options = data['options'];
        // Removed the item with "Nothing specific" text
        var filteredOptions = options.filter(function (option) {
            if (option.id === nothingSpecificOptionId) {
                setNothingSpecific(option);
                return false;
            }
            return true;
        });
        setOptionsData(filteredOptions);
    };
    var unselectIfSelected = function (option, index) {
        var indexToRemove = selectedOptionsMap.findIndex(function (data) { return data.id == option.id; });
        if (indexToRemove != -1) {
            var updatedSelectedOptionsMap = __spreadArray([], selectedOptionsMap, true);
            updatedSelectedOptionsMap.splice(indexToRemove, 1);
            setSelectedOptionsMap(updatedSelectedOptionsMap);
            var updatedSelectedBooleanMap = __spreadArray([], selectedBooleanMap, true);
            updatedSelectedBooleanMap[index] = false;
            setSelectedBooleanMap(updatedSelectedBooleanMap);
            return true;
        }
        return false;
    };
    var optionClickHandler = function (option, index) {
        if (unselectIfSelected(option, index)) {
            sendEventUsingAvo({
                methodName: 'interactedPersonaQuestionScreen',
                params: __assign({ 'clickedOn': 'Option Deselect', 'questionNo': "".concat(questionNumber + 1) }, appendBaseParams({ settings: {}, courses: [], mathGrade: "", elaGrade: "", grade: "", signupFlow: "" }))
            });
        }
        else {
            var updatedSelectedOptionsMap = __spreadArray([], selectedOptionsMap, true);
            updatedSelectedOptionsMap.push(option);
            setSelectedOptionsMap(updatedSelectedOptionsMap);
            var updatedSelectedBooleanMap = __spreadArray([], selectedBooleanMap, true);
            updatedSelectedBooleanMap[index] = true;
            setSelectedBooleanMap(updatedSelectedBooleanMap);
            sendEventUsingAvo({
                methodName: 'interactedPersonaQuestionScreen',
                params: __assign({ 'clickedOn': 'Option Select', 'questionNo': "".concat(questionNumber + 1) }, appendBaseParams({ settings: {}, courses: [], mathGrade: "", elaGrade: "", grade: "", signupFlow: "" }))
            });
        }
    };
    var submitHandler = function (from) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedIdsArray, selectedIdsString, selectedTextsArray, params, updatedQuesNo, e_1, errorInfo;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectedIdsArray = selectedOptionsMap.map(function (data) { return data.id; });
                    selectedIdsString = selectedIdsArray.join(",");
                    selectedTextsArray = selectedOptionsMap.map(function (data) { return data.text; });
                    params = {
                        "survey_details": (_a = {},
                            _a["".concat(personaData[questionNumber].code)] = from == submitTypes.next ? selectedIdsString : "".concat(nothingSpecificOption === null || nothingSpecificOption === void 0 ? void 0 : nothingSpecificOption.id),
                            _a),
                        "student_id": studentId,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    if (!(selectedOptionsMap.length == 0 && from == submitTypes.next)) return [3 /*break*/, 2];
                    setShowErrorMsz(true);
                    // After 3 seconds, reset setShowErrorMsz to false
                    setTimeout(function () {
                        setShowErrorMsz(false);
                    }, 3000);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, SubmitSurvey(params)];
                case 3:
                    _b.sent();
                    if (totalQuestions > 0 && questionNumber < totalQuestions - 1) {
                        updatedQuesNo = questionNumber + 1;
                        setQuestionNumber(updatedQuesNo);
                        // Reset selectedOptionsMap and selectedBooleanMap for next ques
                        setSelectedOptionsMap([]);
                        setSelectedBooleanMap(Array(optionsData.length).fill(false));
                        filterNothingSpecificFromOptions(personaData[updatedQuesNo]);
                    }
                    else {
                        props.goToNextHandler('persona_identification', {});
                    }
                    _b.label = 4;
                case 4:
                    sendEventUsingAvo({
                        methodName: 'interactedPersonaQuestionScreen',
                        params: __assign({ 'clickedOn': from == submitTypes.next ? 'Next CTA' : 'Nothing Specific CTA', 'questionNo': from == submitTypes.next ? "".concat(questionNumber + 1) : undefined, 'optionsSelected': from == submitTypes.next ? selectedTextsArray : undefined, 'errorMessage': from == submitTypes.next ? (selectedOptionsMap.length == 0 ? 'Shown' : 'Not Shown') : undefined }, appendBaseParams({ settings: {}, courses: [], mathGrade: "", elaGrade: "", grade: "", signupFlow: "" }))
                    });
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _b.sent();
                    errorInfo = {
                        extraMsg: 'submit survey api failed',
                    };
                    sendErrorToSentry(e_1, errorInfo);
                    return [2 /*return*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (dataLoaded &&
        React.createElement(React.Fragment, null,
            React.createElement(S.Heading, null, personaData[questionNumber].text),
            React.createElement(S.SubHeading, null, "Select all the relevant options"),
            React.createElement(S.OptionsWrapper, null, optionsData.map(function (option, index) {
                return React.createElement(S.Option, { key: index, onClick: function () { return optionClickHandler(option, index); }, active: selectedBooleanMap[index] },
                    option.text,
                    selectedBooleanMap[index] && React.createElement(Image, { src: TickIcon, alt: 'tick-icon' }));
            })),
            React.createElement(S.CTAWrapper, null,
                showErrorMsz && React.createElement(S.Text, null, "Please select at least one option"),
                React.createElement(S.CTAButton, { "data-testid": "next-cta", onClick: function () { return submitHandler(submitTypes.next); } }, "Next"),
                React.createElement(S.CTAButton2, { "data-testid": "nothing-specific-cta", onClick: function () { return submitHandler(submitTypes.nothing); }, disableCta: selectedOptionsMap.length > 0 }, "Nothing specific"))));
};
export default PersonaIdentification;
